import React, {FC, Fragment} from 'react';
import {useTranslation} from 'react-i18next';

interface Props {
  value?: string | number;
}

const Currency: FC<Props> = props => {
  const {value} = props;

  const {t} = useTranslation();
  return (
    <Fragment>
      {t('numbers.currency', {
        val: value ?? 0,
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      })}
    </Fragment>
  );
};

export default Currency;
